import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractUserRelatedDataService } from '@y42/feature';
import { SqlModelingQuery, SqlModelingState, SqlModelingStore } from '../../state';

@Injectable({ providedIn: 'root' })
export class SqlModelingUserDataService extends AbstractUserRelatedDataService<SqlModelingState> {
  constructor(readonly http: HttpClient, readonly store: SqlModelingStore, readonly query: SqlModelingQuery) {
    super({
      http,
      store,
      query,
      URLs: {
        last_used: 'sql-modeling-last_used',
        starred: 'sql-modeling-starred',
      },
    });
  }
}
